// extracted by mini-css-extract-plugin
export var closeButton = "_21-3";
export var header = "_21-0";
export var link = "_21-1";
export var retryButton = "_21-2";